import { render, staticRenderFns } from "./DiagnosticoInicialPTI.vue?vue&type=template&id=77606e93&scoped=true"
import script from "./DiagnosticoInicialPTI.vue?vue&type=script&lang=js"
export * from "./DiagnosticoInicialPTI.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticoInicialPTI.vue?vue&type=style&index=0&id=77606e93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77606e93",
  null
  
)

export default component.exports